/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { FunctionComponent } from 'react';

import './Star.scss';

interface StarProps {
    // Should be a float between [0, 1]
    fill: number;
}

const Star: FunctionComponent<StarProps> = ({ fill }) => {
    const fillPercent = fill * 100 > 100 ? 100 : fill * 100;

    return (
        <div className="star-container">
            <div className="empty-star"></div>
            <div style={{ width: `${fillPercent}%` }} className="star-fill"></div>
        </div>
    );
};

export default Star;
